<template>
  <div>
    <input type="checkbox" class="form-check-input mr-0 ml-0" :value="checked" :v-model="checked" :checked="checked" @change="onChange" :id="id"/>
    <label v-if="label" class="ml-3" :for="id">{{ label }}</label>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
export default {
  props: {
    id: {
      default() {
        return `checkbox-${uuid()}`
      },
    },
    active: Boolean,
    error: String,
    label: String,
    checked: Boolean,
  },
  data() {
    return {
      checked: this.active
    }
  },
  methods: {
    onChange() {
      this.checked = !this.checked;
      this.$emit('input', this.checked);
    }
  },
}
</script>